export default __webpack_public_path__ + "88e75bab2476d4866499f7a36f404bf0.png";